'use client';

import { useMemo } from 'react';
import cn from 'classnames';
import styles from './ChatStatusBanner.module.scss';
import { KibIcon, KibChewyIcon } from '@chewy/kib-icons-react';
import '@chewy/kib-patterns/dist/styles/kib-icon.css';

export interface ChatStatusBannerProps {
    isAgentJoined?: boolean;
    isChatEnded?: boolean;
    agentName?: string;
}

export default function ChatStatusBanner({ isAgentJoined = false, isChatEnded = false, agentName }: ChatStatusBannerProps) {
    const text = useMemo(() => {
        if (isAgentJoined && agentName) {
            return `${agentName} is in the chat`;
        }
        if (isChatEnded) {
            return 'Chat ended';
        }
        return null;
    }, [agentName, isAgentJoined, isChatEnded]);

    if (!text) return null;

    return (
        <div className={styles.background}>
            <div className={cn(styles.container, {
                [styles.containerAvailable]: isAgentJoined,
                [styles.containerUnavailable]: isChatEnded,
            })}>
                <div className={styles.badgeWrapper}>
                    <KibIcon>
                      <KibChewyIcon />
                    </KibIcon>
                    <span className={styles.badge} />
                </div>
                <span className={styles.text}>{text}</span>
            </div>
        </div>
    );
}
